import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';

/**
 * Used only within the Test branch of `quick_find_jira_recommendations`.
 * Statsig expects a string `cohort`: `control` or `test`; only `test` selects tenant storage.
 * Before enabling treatment, verify CG support is deployed and recurring ML writes refresh both tables.
 */
const EXPERIMENT = 'quick_find_jira_recs_tenant_storage';

/** Read without exposure so the controller can keep its cache scoped to the selected model. */
export const getQuickFindJiraRecommendationsModel = (): string =>
	UNSAFE_expValNoExposure<string>(EXPERIMENT, 'cohort', 'control') === 'test'
		? 'quickfind_jira_user_recs_tb'
		: 'quickfind_user_recs_challenger_2';

/** Enroll both arms inside the existing Test branch, after eligibility guards, before coverage is known. */
export const triggerQuickFindJiraRecommendationsModelExposure = (): void => {
	expVal(EXPERIMENT, 'cohort', 'control');
};
